import { useEffect, useRef } from "react";
import "./OrderSuccess.css";
import { Link } from "react-router-dom";

const OrderSuccess = ({ onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="ordersuccess">
      <div className="ordersuccess-content" ref={modalRef}>
        <div className="orderclose-button">
          <button onClick={onClose}>&#10006;</button>
        </div>
        <div className="ordersuccess-title">
          <strong>Payment Successful!</strong>
        </div>

        <div className="ordersuccess-main">
          Your order has been placed successfully! We'll process it and aim to
          ship within 2-4 business days.
          <br />
          Thank you for shopping with us!
        </div>

        <div className="ordersuccess-sub">
          <Link to="/">
            <div className="backhome">
              <button>BACK TO HOME</button>
            </div>
          </Link>
          <Link to="/allorder">
            <div className="vieworder">
              <button>VIEW MY ORDER</button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
